export const PRODUCTS_CHECK_PERMISSION = 'PRODUCTS_CHECK_PERMISSION';
export const PRODUCTS_UNCHECK_PERMISSION = 'PRODUCTS_UNCHECK_PERMISSION';
export const RETAILERS_SET_ORDER = 'RETAILERS_SET_ORDER';
export const RETAILERS_SET_ORDER_FIELD = 'RETAILERS_SET_ORDER_FIELD';
export const BRAND_ORDERS_RETAILER_FILTER = 'BRAND_ORDERS_RETAILER_FILTER';
export const CHANGE_DATE_RANGE = 'CHANGE_DATE_RANGE';
